#version 300 es
/*
* Preprocessed + Optimized from './lut.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;
uniform mediump sampler3D lut;
uniform float u_intensity;

in vec2 vTextureCoord;
layout(location = 0) out vec4 fragColor;

void main()
{
    vec4 _74 = texture(uTexture, vTextureCoord);
    highp vec3 _93 = vec3(textureSize(lut, 0));
    fragColor = mix(_74, vec4(texture(lut, ((_74.xyz * (_93 - vec3(1.0))) + vec3(0.5)) / _93).xyz, _74.w), vec4(u_intensity));
}
